<template>
  <span
    class="inline-block bg-white rounded-full"
    :class="[
      `text-score-${getScoreLabel(score)}`,
      { 'w-12 h-12': size === 'xs', 'w-20 h-20': size === 'sm', 'w-28 h-28': size === 'md' },
    ]"
  >
    <svg
      class="w-full h-full pointer-events-none"
      :class="{ 'p-px': size === 'xs', 'p-1.5': size === 'sm', 'p-3': size === 'md' }"
      viewBox="0 0 36 36"
    >
      <title v-if="withA11yTitle">{{ providerName ?? '' }} {{ $t('monito_score') }}</title>
      <path
        class="stroke-current text-gray-200"
        d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
        fill="none"
        stroke-width="3"
        stroke-dasharray="100, 100"
      />
      <path
        class="opacity-0 stroke-current"
        :class="{ 'animated-circle-active': animationReady }"
        d="M18 2.0845
            a 15.9155 15.9155 0 0 1 0 31.831
            a 15.9155 15.9155 0 0 1 0 -31.831"
        fill="none"
        stroke-width="3"
        :stroke-dasharray="`${score ? score * 10 : 0}, 100`"
      />
    </svg>
    <strong
      class="font-bold leading-normal absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
      :class="{ 'text-10': size === 'xs', 'text-20': size === 'sm', 'text-24': size === 'md' }"
    >
      {{ displayScore }}
    </strong>
  </span>
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    score?: number
    withA11yTitle?: boolean
    providerName?: string
    size?: 'sm' | 'md' | 'xs'
  }>(),
  { size: 'md' },
)

const { $lang } = useNuxtApp()

const animationReady = ref(false)

onMounted(() => {
  animationReady.value = true
})

const displayScore = computed(() => {
  if (props.score === 10) {
    return String(props.score)
  } else if (typeof props.score === 'number') {
    return formatNumber(props.score, $lang, { minimumFractionDigits: 1, maximumFractionDigits: 1 })
  }
  return '?'
})
</script>

<style scoped>
.animated-circle-active {
  opacity: 1;
  animation-name: appear;
  animation-duration: 0.8s;
  animation-delay: 0.5s;
  animation-timing-function: ease-in-out;
  animation-fill-mode: backwards;
}

@keyframes appear {
  0% {
    opacity: 0;
    stroke-dasharray: 0 100;
  }

  30% {
    opacity: 1;
  }
}
</style>
